import React from "react";
import CustomButton from "../CustomButton";

function FormButtons({
  goBackLabel,
  goNextLabel,
  handleGoBack,
  handleGoNext,
  nextButtonDisabled,
}: {
  goBackLabel?: string;
  goNextLabel?: string;
  handleGoBack?: () => void;
  handleGoNext?: () => void;
  nextButtonDisabled?: boolean;
}) {
  return (
    <div className="d-flex justify-content-between mt-6">
      {goBackLabel && (
        <CustomButton
          variant="outlined"
          className="me-2"
          onClick={handleGoBack}>
          {goBackLabel}
        </CustomButton>
      )}
      {goNextLabel && (
        <CustomButton
          variant="contained"
          className="me-2"
          disabled={nextButtonDisabled}
          onClick={handleGoNext}>
          {goNextLabel}
        </CustomButton>
      )}
    </div>
  );
}

export default FormButtons;
